import { combineReducers } from "redux";

// Front
import LayoutReducer from "./layouts/reducer";
import LoginReducer from "./auth/login/reducer";
import ProfileReducer from "./auth/profile/reducer";
import ForgotPasswordReducer from "./auth/forgetpwd/reducer";
import AccountReducer from "./auth/register/reducer";
import ResetPasswordReducer from "./auth/resetpwd/reducer";
import EntityReducer from "./auth/registerEntity/reducer";
import UserSystem from "./user-system/reducer";
import RolesReducer from "./roles/reducer";
import WalletReducer from "./crypto/reducer";
import { configureStore } from "@reduxjs/toolkit";

//Redux persist
import storageSession from "redux-persist/lib/storage/session";
import { persistStore, persistReducer, Persistor } from "redux-persist";
import { decryptState, encryptState } from "shared/encryptInfo";

//Configuracion de la persistencia
const persistConfig: any = {
  key: "root",
  storage: storageSession,
  serialize: encryptState,
  deserialize: decryptState,
};

const rootReducer = combineReducers({
  Layout: LayoutReducer,
  Login: LoginReducer,
  Profile: ProfileReducer,
  ForgetPassword: ForgotPasswordReducer,
  ResetPassword: ResetPasswordReducer,
  Account: AccountReducer,
  Entity: EntityReducer,
  UserSystem: UserSystem,
  Roles: RolesReducer,
  WalletReducer,
  // Aca se deberian de importar todo el resto de recuders de la carpeta Slice, por el
  //  momento no se hace ya que los reduces que estan no son los oficiales
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Necesario para evitar errores con Redux Persist
    }),
});

// Permite persistir el almacenamiento
export const persistor: Persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
